import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { WWOTopAdNetworksSI } from "./WWOTopAdNetworksSI";

export const WWOTopAdNetworksContainerSI = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    if (!salesSettingsHelper.isSiAdNetworksFeatureEnabled) {
        return null;
    }

    const params = proNavigator.getParams();
    const isCompare = params.key.split(",").length > 1;

    const getCtaLink = () => ({
        href: proNavigator.href("accountreview_website_display_ad_networks", params),
        target: "_self",
    });

    return (
        <WWOTopAdNetworksSI
            getCtaLink={getCtaLink}
            isCompare={isCompare}
            unlockHook={{
                component: "WsWebDisplayTrafficAdNetworks",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            hideFooter={hideFooter}
        />
    );
};
